import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import Link from "next/link";
import { NextSeo } from "next-seo";

import Header from "../components_web/Header";
import Footer from "../components_web/Footer";
import SideMenu from "../components_web/SideMenu";
import { getClass } from "../src/helpers/formatHelpers";

const Legal = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);

  return (
    <div>
      <NextSeo
        title={`Legal - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        canonical={`https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/legal`}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/legal`,
          title: `Legal - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className={`${getClass("background5", true)}`}>
        <div className="wrapper mx-auto relative py-40 min-h-screen">
          <div className="mx-auto max-w-440px">
            <div className="flex flex-col items-center">
              <h1
                className={`text-3xl font-bold ${getClass(
                  "text-white",
                  true
                )} text-center mb-16`}>
                {t("key_web_legal")}
              </h1>
              {/* <Link prefetch={false} href="/business">
                <a className={`text-lg ${getClass('text-white', true)} hover:underline font-semibold text-center w-full mb-6`}>
                  Business
                </a>
              </Link> */}
              <a
                href="/privacy-policy"
                className={`text-lg ${getClass(
                  "text-white",
                  true
                )} hover:underline font-semibold text-center w-full mb-6`}>
                Privacy Policy
              </a>
              <a
                href="/t-cs"
                className={`text-lg ${getClass(
                  "text-white",
                  true
                )} hover:underline font-semibold text-center w-full mb-6`}>
                T & C
              </a>
              {/* <a
                href="/eula"
                className={`text-lg ${getClass('text-white', true)} hover:underline font-semibold text-center w-full mb-6`}>
                EULA
              </a> */}
              <a
                href="/disclaimer"
                className={`text-lg ${getClass(
                  "text-white",
                  true
                )} hover:underline font-semibold text-center w-full mb-6`}>
                Disclaimer
              </a>
              {/* <a
                href="https://app.termly.io/notify/ae4b019d-e94c-4e13-b72d-df2bdc135438"
                className={`text-lg ${getClass('text-white', true)} hover:underline font-semibold text-center w-full mb-6`}
                target="_blank"
                rel="noreferrer">
                DSAR Form
              </a> */}
              {/* <Link prefetch={false} href="/materials-license">
                <a className={`text-lg ${getClass('text-white', true)} hover:underline font-semibold text-center w-full mb-6`}>
                  Materials Licence T&C
                </a>
              </Link> */}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Legal;
